import { useEffect, useState, type RefObject } from 'react';

const MIN_TABLE_HEIGHT = 280;

/**
 * Measure an element's height for flex-filled virtualized tables.
 * Observes the element and its parent so flex layouts settle before measure.
 */
export function useContainerHeight(ref: RefObject<HTMLElement | null>): number {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const update = () => {
      let h = el.clientHeight;
      if (h < MIN_TABLE_HEIGHT && el.parentElement) {
        h = Math.max(h, el.parentElement.clientHeight);
      }
      setHeight(h);
    };

    update();

    const ro = new ResizeObserver(update);
    ro.observe(el);
    if (el.parentElement) ro.observe(el.parentElement);

    return () => ro.disconnect();
  }, [ref]);

  return height;
}
